import React from "react";

import { Box, Typography } from "@mui/material";
import { round, sum } from "lodash";
import { makeStyles } from "tss-react/mui";

import { calculateMacro } from "@/pages/Clients/ClientDetails/ClientDiary/Meals/utils/macros";

import MealPatternItem from "../store/MealPatternItem";
import { PlannedMealItem } from "../store/PlannedMealItem";

interface Props {
  items: PlannedMealItem[] | MealPatternItem[] | undefined;
}

const MealItemMacros: React.FC<Props> = ({ items }) => {
  const { classes } = useStyles();

  const totalEnergy = round(sum(items?.map((f) => f.energyKcal)));
  const totalCarbs = round(sum(items?.map((f) => f.carbohydrateGrams)), 2);
  const totalProteins = round(sum(items?.map((f) => f.proteinGrams)), 2);
  const totalFat = round(sum(items?.map((f) => f.fatGrams)), 2);
  const calculate = calculateMacro(totalEnergy);
  const carbsPercent = calculate.carbsPercentage(totalCarbs);
  const proteinsPercent = calculate.proteinPercentage(totalProteins);
  const fatPercent = calculate.fatsPercentage(totalFat);

  return (
    <Box className={classes.root}>
      <Typography>
        C: {totalCarbs} g | {carbsPercent} %
      </Typography>
      <Typography>
        P: {totalProteins} g | {proteinsPercent} %
      </Typography>
      <Typography>
        F: {totalFat} g | {fatPercent} %
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles()({
  root: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 12,
  },
});

export default MealItemMacros;
